export enum AssetCategory {
    Sighting = 1,
    KeyAsset = 2,
    Trackside = 3,
    User = 4
}
